// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1PoIL","label":"Category_label__347pt","content":"Category_content__2t0aV","header":"Category_header__2xHsE","location":"Category_location__2FxRl"};